<template>
  <div class="xyjdck">
    <Header title="学业进度查看"></Header>
    <!-- <NOdata title="暂无学业进度查看数据~" v-if="this.recordList.length == 0"></NOdata> -->
    <div class="xyjdck_main">
      <div class="xyjdck_main_header">
        <h3>
          {{ info.xdfamc ? info.xdfamc : "-" }}
        </h3>
        <p>{{ info.xm ? info.xm : "-" }}-{{ info.xh ? info.xh : "-" }}</p>
        <p>班级：{{ info.bjmc ? info.bjmc : "-" }}</p>
      </div>
      <div class="xyjdck_main_content">
        <div class="content_top">
          <el-table
            show-summary
            border
            style="width:100%"
            :data="sumTableData"
            sum-text="总计"
          >
            <el-table-column align="center" prop="dmmc" label="课程属性">
            </el-table-column>
            <el-table-column align="center" prop="yqxf" label="应修学分">
            </el-table-column>
            <el-table-column align="center" prop="yxzxf" label="已修学分">
            </el-table-column>
          </el-table>
        </div>
        <div class="content_center">
          <van-tabs v-model="active" scrollspy sticky offset-top="50px">
            <van-tab :title="key" v-for="(item, key) of tableData" :key="key">
              <mode-table :title="key" :tableData="item"></mode-table>
            </van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import modeTable from "./modeTable.vue";
export default {
  components: { modeTable },
  data() {
    return {
      active: 0,
      title: "",
      info: {},
      sumTableData: [],
      tableData: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.xxwcqkOnkcxz();
      if (res.code == "1") {
        this.info.xdfamc = res.data.xdfamc;
        this.info.xh = res.data.xh;
        this.info.xm = res.data.xm;
        this.info.bjmc = res.data.bjmc;
        this.sumTableData = res.data.allKcxfqk;
        this.tableData = res.data.kcsxkcMap;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.xyjdck {
  height: 100%;
  background-color: #f2f2f4;
  .xyjdck_main {
    height: 100%;
    display: flex;
    flex-direction: column;
    .xyjdck_main_header {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px 60px 55px;
      z-index: 1;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 305px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        background-image: url("~@/assets/images/xyjdck_main_header.png");
        z-index: -1;
      }
      h3 {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: bolder;
        word-break: break-all;
      }
      p {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .xyjdck_main_content {
      flex: 1;
      background-color: #f2f2f4;
      margin-top: -15px;
      border-radius: 12px 12px 0px 0px;
      padding: 15px;
      z-index: 1;
      .content_top {
        background: #ffffff;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
  // van-tabs
  /deep/.van-sticky--fixed {
    padding: 0 15px;
  }
  /deep/.van-tabs--line {
    .van-tabs__wrap {
      height: 50px;
      .van-tabs__nav--line {
        background-color: #f2f2f4;
        padding-bottom: 0;
        margin: 0 -8px;
        .van-tab {
          position: relative;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #999999;
          letter-spacing: 0;
          font-weight: 400;
          &.van-tab--active {
            color: #333333;
            font-weight: bolder;
          }
        }
        .van-tabs__line {
          background-color: #7469f8;
          bottom: 10px;
        }
      }
    }
  }

  // el-table
  /deep/.el-table {
    thead {
      th {
        padding: 8px 0;
        background-color: #f9f9f9;

        .cell {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #333333 !important;
          letter-spacing: 0;
          font-weight: bolder;
        }
      }
    }
    tbody {
      td {
        padding: 8px 0 !important;
        background-color: #fff;
        border-bottom: 1px solid #ebeef5 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xyjdck/index.vue